module.exports = __webpack_public_path__ + "img/com.electrolux.epr.ZanussiPricelist.7ee01db6.webp";